export const GENERAL_TABS_ACTIVE_TAB = 'GENERAL_TABS_ACTIVE_TAB'
export const GENERAL_TABS_REMOVE_DATA = 'GENERAL_TABS_REMOVE_DATA'
